<template>
  <div>
    <vxe-grid
      ref="spuTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      row-id="amzSpuCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzSpuStatus === 'D'
              ? 'danger'
              : row.amzSpuStatus === 'Q'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_amzSpuStatus }}
        </el-tag>
        <el-tag
          v-if="row.v_applicationStatus && row.applicationStatus !== 'M'"
          size="mini"
          class="ml-2"
          effect="plain"
          :type="
            row.applicationStatus === 'R'
              ? 'danger'
              : row.applicationStatus === 'P'
              ? 'light'
              : 'success'
          "
        >
          {{ row.v_applicationStatus }}
        </el-tag>
        <div v-if="row.rejectReason" style="color:red" class="mt-2">
          {{ row.rejectReason }}
        </div>
      </template>
      <template v-slot:isVc="{ row }">
        <el-tag
          size="mini"
          v-if="row.isVc"
          :type="row.isVc === 'N' ? 'info' : 'warning'"
        >
          {{ row.v_isVc }}
        </el-tag>
      </template>

      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SPU：</span><span style="color: #409EFF">{{ row.amzSpuNo }}</span>
      </template>
      <template v-slot:designAndBuyer="{ row }">
        <span>PM：</span
        ><span style="color: #303133">{{ row.designName }}</span>
        <!-- <br />
        <span>PC：</span><span style="color: #303133">{{ row.buyerName }}</span> -->
      </template>

      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: false },
    highlight: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      zoom: true,
      custom: true,
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ newValue }) {
      this.$emit('choose-change', newValue)
    },
    clearCheckboxRow() {
      this.$refs.spuTable.clearCheckboxRow()
      this.$refs.spuTable.clearCheckboxReserve()
      this.$emit('choose-change', [])
    },
  },
}
</script>
